/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SearchComponent from '../search/search';
import { fuzzySearch } from '../../../helper/search';

// getVisibleOptions :: [Object: a] -> String -> [Object: a]
const getVisibleOptions = (options) => (filterOptionsValue) => {
  const search = fuzzySearch({
    data: options,
    searchKeys: ['label'],
    options: { caseSensitive: false }
  });

  return search(filterOptionsValue);
};

const defaultState = { isOpen: false, filterOptionsValue: '' };

class SelectComponent extends Component {
  state = defaultState;

  componentDidMount() {
    document.addEventListener('click', this.documentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.documentClick);
  }

  selectorRef = React.createRef();

  documentClick = (event) => {
    const target = event.target;
    const { current } = this.selectorRef;

    current !== target && !current.contains(target) && this.setState(() => defaultState);
  };

  onValueChange = ({ value, label }) => {
    return () => {
      this.props.onChange({ value, label });
      this.setState(() => defaultState);
    };
  };

  openDropdown = (event) => {
    const { isOpen } = this.state;

    isOpen && event.nativeEvent.stopImmediatePropagation();
    this.setState(() => ({ ...defaultState, isOpen: !isOpen }));
  };

  filterSelectOptions = (filterOptionsValue) => {
    this.setState(() => ({ filterOptionsValue }));
  };

  render() {
    const { label = '', selectedValue = {}, options = [], id = '', searchable } = this.props;
    const { isOpen, filterOptionsValue } = this.state;
    const visibleOptions = getVisibleOptions(options)(filterOptionsValue);

    return (
      <div className="select-component-common">
        {label && <div className="select-component-label">{label}</div>}
        <div className={classnames('select-component-selector-wrapper', { visible: isOpen })}>
          <div
            id={id}
            className={classnames('select-component-selector', { 'is-open': isOpen, searchable })}
            onClick={this.openDropdown}
            ref={this.selectorRef}
            title={selectedValue.label}
          >
            <span>{(!isOpen || !searchable) && selectedValue.label}</span>

            {isOpen && searchable && (
              <SearchComponent id="search-options" initFocus onChange={this.filterSelectOptions} />
            )}
          </div>

          {isOpen && (
            <div className="select-component-options">
              {visibleOptions.length > 0 &&
                visibleOptions.map(({ value, label }) => (
                  <div
                    key={value}
                    className="select-component-option"
                    onClick={this.onValueChange({ value, label })}
                    title={label}
                  >
                    <span>{label}</span>
                  </div>
                ))}

              {visibleOptions.length === 0 && <div className="select-component-option">no available options</div>}
            </div>
          )}
        </div>
      </div>
    );
  }
}

SelectComponent.propTypes = {
  label: PropTypes.string,
  selectedValue: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func,
  id: PropTypes.string,
  searchable: PropTypes.bool
};

export default SelectComponent;
